import { MessageBox, Message } from '@heytap/cook-ui'
import { IFileItem, batchCompress } from '@/service/public'
import { Store } from 'vuex'
export async function compressPrompt(data: IFileItem[], store: Store<any>) {
    if (!data.length) {
        return
    }
    const fileNameValidator = (value?: string) => {
        if (!value) {
            return '名称不能为空！'
        }
        const reg = /^[()0-9a-zA-Z\u4e00-\u9fa5_（）-]+$/
        if (!reg.test(value)) {
            return '名称只能包含数字字母汉字、下划线横线和括号'
        }
        return true
    }
    try {
        const MessageBoxData = await MessageBox.prompt('压缩包命名', '压缩文件', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputValue: data[0].name,
            inputValidator: fileNameValidator,
            closeOnClickModal: false,
        })
        const zipName = (MessageBoxData as any).value

        const ids = data.map(item => item.id)
        const res = await batchCompress({ ids, name: zipName })
        if (res.code === 0) {
            Message.success(res.desc || '成功')
            store.dispatch('publicStore/getTableData')
            store.commit('publicStore/UPDATE_COMPRESS_LIST')
        } else {
            Message.error(res.desc || '失败')
        }
    } catch (error) {
        console.log(error)
    }
}
